import { useQuery } from '@tanstack/react-query';

import { $api } from 'modules/global';

import { IMyResults } from '..';

export const useMyResults = () => {
  const { data, ...args } = useQuery<{ results: IMyResults[] }>({
    queryKey: ['my-results'],
    queryFn: async () => {
      const { data } = await $api.get('/myresult');

      return { results: data?.result };
    }
  });

  return { ...data, ...args };
};
